/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

const DEV = {
  apiKey: "AIzaSyA88D_4_LrwILBBoPda4xqhAQqCWGEsoos",
  authDomain: "stagesprite-c6a6a.firebaseapp.com",
  databaseURL: "https://stagesprite-c6a6a.firebaseio.com",
  projectId: "stagesprite-c6a6a",
  storageBucket: "stagesprite-c6a6a.appspot.com",
  messagingSenderId: "516647356570",
  appId: "1:516647356570:web:8f83bb80ca8ff7ebcfb723"
};

const PROD = {
  apiKey: "AIzaSyBBFt_lp4xTqDiHVQTDNaBIs74kqIeWY1Q",
  authDomain: "stagespritedemo.firebaseapp.com",
  databaseURL: "https://stagespritedemo.firebaseio.com",
  storageBucket: "stagespritedemo.appspot.com"
};

export const firebaseConfig = PROD;

export const appVersion: string = '1.4.12';



// WEBPACK FOOTER //
// ./src/environments/firebase.config.ts